import React from 'react';
import { Box, Tabs, Tab, Stack } from '@mui/material';
import TabPanel, { a11yProps } from '@/components/tab-panel/tab-panel';
import { SystemData } from '../../calculations';
import { SystemBudgetDetails } from './system-budget-details';
import { UserDto } from '@cloudcost/shared-types/users';

interface OwnedSystemsTabsProps {
  ownedSystemList: SystemData[];
  tabValue: number;
  onTabChange: (event: any, newValue: any) => void;
  getCurrentTabSystem: () => SystemData | undefined;
  onRequestBudgetChange?: (system: SystemData) => void;
  onDisputeSystemCost?: (system: SystemData) => void;
  users?: UserDto[];
}

export const OwnedSystemsTabs: React.FC<OwnedSystemsTabsProps> = ({
  ownedSystemList,
  tabValue,
  onTabChange,
  getCurrentTabSystem,
  onRequestBudgetChange,
  onDisputeSystemCost,
  users = [],
}) => {
  if (ownedSystemList.length === 0) {
    return null;
  }

  return (
    <Box sx={{ width: '100%' }}>
      <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
        <Tabs
          value={tabValue}
          onChange={onTabChange}
          variant="scrollable"
          scrollButtons
          allowScrollButtonsMobile>
          {ownedSystemList.map((tab, index) => (
            <Tab key={tab.id} label={tab.name} {...a11yProps(index)} />
          ))}
        </Tabs>
      </Box>

      {ownedSystemList.map((tab, index) => (
        <TabPanel
          key={tab.id}
          value={tabValue}
          index={index}
          padding={0}
          paddingTop={3}>
          <Stack spacing={2}>
            <SystemBudgetDetails
              system={getCurrentTabSystem()}
              onRequestBudgetChange={onRequestBudgetChange}
              onDisputeSystemCost={onDisputeSystemCost}
              users={users}
            />
          </Stack>
        </TabPanel>
      ))}
    </Box>
  );
};
